import HttpRequest from './http_request'

class RegistrationProvider extends HttpRequest {
    constructor() {
        // api api
        super(process.env.VUE_APP_API_URL)
    }

    //===========================================================================
    //ดึงปีการศึกษาภาคการศึกษาของระดับชั้นในปัจจุบัน
    async getYearSemesterNow(level_id, sub_level_id = null) {
        const { data } = await this.get('/', {
            function: 'get-year-semester-now',
            level_id,
            sub_level_id,
        })
        return data
    }
    //ดึงปี-เทอมที่มีสิทธิ์ดูคิว สำหรับเจ้าหน้าที่/อาจารย์
    async getOfficerQueueAcademicTerms() {
        const { data } = await this.get('/', {
            function: 'get-officer-queue-academic-terms',
        })
        return data
    }
    //ดึงวิชา-กลุ่มที่มีสิทธิ์ดูคิวตามปี-เทอม สำหรับเจ้าหน้าที่/อาจารย์
    async getOfficerQueueSubjects({ year, semester }) {
        const { data } = await this.get('/', {
            function: 'get-officer-queue-subjects',
            year,
            semester,
        })
        return data
    }
    //ดึงข้อมูลรายวิชาจาก teach table id
    async getTeachTableData(teach_table_id) {
        const { data } = await this.get('/', {
            function: 'get-teach-table-data',
            TEACH_TABLE_ID: teach_table_id,
        })
        return data
    }
    //ดึงคิวลงทะเบียนของวิชา-กลุ่ม สำหรับเจ้าหน้าที่/อาจารย์
    async getOfficerQueueList({ year, semester, subject_id, section }) {
        const { data } = await this.get('/', {
            function: 'get-officer-queue-list',
            year,
            semester,
            subject_id,
            section,
        })
        return data
    }
    //เช็คช่วงเวลาเกี่ยวกับระบบลงทะเบียน
    async checkRegistrationDateTime({ level_id, year, semester, sub_level_id = null }) {
        const { data } = await this.get('/', {
            function: 'check-registration-datetime',
            level_id,
            year,
            semester,
            sub_level_id,
        })
        return data
    }
    //เช็คสถานะ นศ. ว่าเป็น 'เรียน' เท่านั้น
    async isStudentStudyStatus(student_id, level_id) {
        const { data } = await this.get('/', {
            function: 'is-student-studying-status',
            student_id,
            level_id,
        })
        return data
    }
    //เช็คว่า นศ.เคยลงทะเบียนล่วงหน้าแล้วหรือยังที่ตาราง pre_student_regis
    async isNeverPreRegis({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'is-never-pre-regis',
            student_id,
            year,
            semester,
            level_id,
        })
        return data
    }
    //เช็คข้อมูล นศ. ในตาราง `registrar`.`r_student_no_right`
    async checkNotInStudentNoRight({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'check-not-in-student-no-right',
            student_id,
            year,
            semester,
            level_id,
        })
        return data
    }
    //เช็คว่า ถ้าเป็นเทอม 1 นศ.ปี 1 จะไม่สามารถลงทะเบียนล่วงหน้าได้
    async isNotSemester1andNotStudentFirst1({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'is-not-first-semester-and-not-freshman-student',
            student_id,
            year,
            semester,
            level_id,
        })
        return data
    }

    // ดึงข้อมูลรายวิชา
    async getCanRegisterByStudentIdAndSubjectId({ subject_id, student_id, year, semester, bypass = false }) {
        const { data } = await this.get('/', {
            function: 'get-can-register-by-student-id-and-subject-id',
            subject_id, student_id, year, semester, bypass
        })
        return data;
    }

    // ลงข้อมูลการลงทะเบียน
    async regisPreRegis({ student_id, year, semester, level_id, teach_table_id_list }) {
        const { data } = await this.create('/', {
            function: 'regis-pre-regis',
            student_id, year, semester, level_id, teach_table_id_list,
        })
        return data;
    }

    // ดึงข้อมูลการลงทะเบียน
    async getPreRegisResult({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'get-pre-regis-result',
            student_id, year, semester, level_id
        })
        return data;
    }

    // ดึงข้อมูลจำนวนเครดิตวิชา ต่ำสุด สูงสุด ที่ลงได้
    async getStudentCredit({ level_id, semester, student_id, sub_level_id = null }) {
        const { data } = await this.get('/', {
            function: 'get-student-credit',
            level_id, semester, student_id, sub_level_id
        })
        return data;
    }

    //ดึงวิชา pattern ของ นศ.
    async getPatternSubject(student_id) {
        const { data } = await this.get('/', {
            function: 'get-pattern-subject',
            student_id,
        })
        return data
    }

    //ดึงวิชาในตาราง COURSE_SPECIAL
    async getCourseSpecial(course_type) {
        const { data } = await this.get('/', {
            function: 'get-course-special',
            course_type,
        })
        return data
    }

    //===========================================================================

    //เช็คว่า นศ.เคยลงทะเบียนล่วงหน้าแล้วหรือยังที่ตาราง student_regis
    async isNeverRegis({ student_id, year, semester, level_id, sub_level_id = null }) {
        const { data } = await this.get('/', {
            function: 'is-never-regis',
            student_id,
            year,
            semester,
            level_id,
            sub_level_id,
        })
        return data
    }
    //===========================================================================

    //
    async getQueueGrantedList({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'get-queue-granted-list',
            student_id,
            year,
            semester,
            level_id,
        })
        return data
    }

    // 
    async getQueueNoRightList({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'get-queue-no-right-list',
            student_id,
            year,
            semester,
            level_id,
        })
        return data
    }

    // 
    async getQueueUsedGrantedsList({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'get-queue-used-granteds-list',
            student_id,
            year,
            semester,
            level_id,
        })
        return data
    }

    // 
    async getQueueCancelList({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'get-queue-cancel-list',
            student_id,
            year,
            semester,
            level_id,
        })
        return data
    }

    // 
    async getQueueTimeSubjectCancelList({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'get-queue-time-subject-cancel-list',
            student_id,
            year,
            semester,
            level_id,
        })
        return data
    }

    // 
    async getQueueSubjectList({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'get-queue-subject-list',
            student_id,
            year,
            semester,
            level_id,
        })
        return data
    }

    // 
    async getInvalidQueue({ student_id, year, semester, level_id }) {
        const { data } = await this.get('/', {
            function: 'get-queue-invalid',
            student_id,
            year,
            semester,
            level_id,
        })
        return data
    }

    //
    async cancelQueue({ student_id, year, semester, level_id, teach_table_id }) {
        const { data } = await this.delete('/', {
            function: 'cancel-queue',
            student_id,
            year,
            semester,
            level_id,
            teach_table_id,
        })
        return data
    }

    //===========================================================================

    // ลงข้อมูลการลงทะเบียน
    async regis({
        student_id, year, semester, level_id, teach_table_id_list, sub_level_id = null, subject_type_list = null, credit_list = null, bypass = false }) {
        const { data } = await this.create('/', {
            function: 'regis',
            student_id, year, semester, level_id, teach_table_id_list, sub_level_id, subject_type_list, credit_list, bypass
        })
        return data;
    }

    // ดึงข้อมูลการลงทะเบียน
    async getRegisResult({ student_id, year, semester, level_id, sub_level_id = null }) {
        const { data } = await this.get('/', {
            function: 'get-regis-result',
            student_id, year, semester, level_id, sub_level_id
        })
        return data;
    }

    // ดึงข้อมูลการลงทะเบียน
    async getRegisTransaction({ student_id, year, semester, level_id, sub_level_id = null }) {
        const { data } = await this.get('/', {
            function: 'get-regis-transaction',
            student_id, year, semester, level_id, sub_level_id
        })
        return data;
    }

    //===========================================================================

    async regisAdd({ student_id, year, semester, level_id, teach_table_id_list, sub_level_id = null, subject_type_list = null, credit_list = null, bypass = false }) {
        const { data } = await this.create('/', {
            function: 'regis-add',
            student_id, year, semester, level_id, teach_table_id_list, sub_level_id, subject_type_list, credit_list, bypass
        })
        return data;
    }

    async regisWithdraw({ student_id, year, semester, level_id, teach_table_id_list, sub_level_id = null, subject_type_list = null, credit_list = null, bypass = false }) {
        const { data } = await this.create('/', {
            function: 'regis-withdraw',
            student_id, year, semester, level_id, teach_table_id_list, sub_level_id, subject_type_list, credit_list, bypass
        })
        return data;
    }

    async regisChange({ student_id, year, semester, level_id, old_teach_table_id_list, new_teach_table_id_list, sub_level_id = null, new_subject_type_list = null, new_credit_list = null, bypass = false }) {
        const { data } = await this.create('/', {
            function: 'regis-change',
            student_id, year, semester, level_id, old_teach_table_id_list, new_teach_table_id_list, sub_level_id, new_subject_type_list, new_credit_list, bypass
        })
        return data;
    }

    //===========================================================================

    //เช็คว่าเป็นนศ.แววนวัตกร
    async isFutureInnovationStudent(student_id) {
        const { data } = await this.get('/', {
            function: 'is-future-innovation-student',
            student_id: student_id
        })
        return data
    }

    // ดึงข้อมูลรายวิชาระดับบัณฑิต - แววนวัตกร
    async getCanRegisterByStudentIdAndSubjectIdX({ subject_id, student_id, year, semester, bypass = false }) {
        const { data } = await this.get('/', {
            function: 'get-can-register-by-student-id-and-subject-id-x',
            subject_id, student_id, year, semester, bypass
        })
        return data;
    }

    //===========================================================================

    // ลงทะเบียนรักษาสถานภาพ / ลาพัก / ยกเลิกการลงทะเบียน 
    async regisMaintainAndDrop({
        level_id, sub_level_id, year, semester, student_id, regis_type }) {
        const { data } = await this.create('/', {
            function: 'regis-maintain-and-drop',
            level_id, sub_level_id, year, semester, student_id, regis_type
        })
        return data;
    }
}

export default RegistrationProvider
